import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import MyBookings from "./pages/MyBookings";
import BookingConfirmation from "./pages/BookingConfirmation";
import PaymentSuccess from "./pages/PaymentSuccess";
import OrganizerDashboard from "./pages/OrganizerDashboard";
import OrganizerAttendees from "./pages/OrganizerAttendees";
import OwnerDashboard from "./pages/OwnerDashboard";
import DoorScanner from "./pages/DoorScanner";
import OrganizerPage from "./pages/OrganizerPage";
import AuthCallback from "./pages/AuthCallback";

function AppRouter() {
  const location = useLocation(); // read hash from here, not window.location.hash (not reactive)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/events" element={<Events />} />
      <Route path="/events/:id" element={<EventDetail />} />
      <Route path="/organizers/:id" element={<OrganizerPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/my-bookings" element={<ProtectedRoute><MyBookings /></ProtectedRoute>} />
      <Route path="/bookings/:id" element={<ProtectedRoute><BookingConfirmation /></ProtectedRoute>} />
      <Route path="/organizer" element={<ProtectedRoute role="organizer"><OrganizerDashboard /></ProtectedRoute>} />
      <Route path="/organizer/events/:id/attendees" element={<ProtectedRoute role="organizer"><OrganizerAttendees /></ProtectedRoute>} />
      <Route path="/organizer/scan" element={<ProtectedRoute role="organizer"><DoorScanner /></ProtectedRoute>} />
      <Route path="/owner" element={<ProtectedRoute role="admin"><OwnerDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App min-h-screen bg-[#2B0B15] text-zinc-100">
      <AuthProvider>
        <BrowserRouter>
          <Header />
          <main>
            <AppRouter />
          </main>
          <Footer />
          <Toaster theme="dark" position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
